export const METADATA_CONDITION_OPERATORS = [
  'equals',
  'is_one_of',
  'contains',
  'not_equals',
  'is_truthy',
  'is_falsy',
  'exists',
  'not_exists',
] as const;

export type MetadataRunConditionOperator = (typeof METADATA_CONDITION_OPERATORS)[number];

export type MetadataRunConditionDto = {
  id: number | string;
  metadata_key: string;
  operator: MetadataRunConditionOperator;
  value: string | null;
  values?: string[];
};
